import React from "react";
import { PPTSeverityBadge } from "../../PPTSeverityBadge";

const SeverityCellRenderer = ({ value }) => {
  if (!value) return null;
  return <PPTSeverityBadge severity={value} />;
};

export default SeverityCellRenderer;
